import { render, staticRenderFns } from "./zhengwuYueFaWen.vue?vue&type=template&id=7b1c3079&scoped=true"
import script from "./zhengwuYueFaWen.vue?vue&type=script&lang=js"
export * from "./zhengwuYueFaWen.vue?vue&type=script&lang=js"
import style0 from "./zhengwuYueFaWen.vue?vue&type=style&index=0&id=7b1c3079&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1c3079",
  null
  
)

export default component.exports